import { render, staticRenderFns } from "./ProjectPreviewNew.vue?vue&type=template&id=8f131494"
import script from "./ProjectPreviewNew.vue?vue&type=script&lang=js"
export * from "./ProjectPreviewNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports